import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=52748fac&scoped=true&lang=pug&"
import script from "./Copyable.vue?vue&type=script&lang=js&"
export * from "./Copyable.vue?vue&type=script&lang=js&"
import style0 from "./Copyable.vue?vue&type=style&index=0&id=52748fac&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52748fac",
  null
  
)

export default component.exports